import React from 'react';
import { Provider } from 'react-redux';
import { useTranslator } from 'tradera-lang';
import DfpAd from '@tradera/blueprint/components/lib/ads';
import ApplicationErrorBoundary from 'tradera-components/application-error-boundary/application-error-boundary';
import '@tradera/blueprint/components/lib/ads.css';
import WaitForConsentApiLoaded from 'tradera-components/wait-for-consent-api-loaded/wait-for-consent-api-loaded';
import { globalStore } from 'tradera-state/configure-store';

const LocalizedDfpAd = props => {
    const { t } = useTranslator();
    const text = {
        label: t('dfpAd_label')
    };
    const store = globalStore();
    const featureSwitches = store.getState().environment.featureSwitches;
    return (
        <ApplicationErrorBoundary capture={false}>
            <Provider store={store}>
                <WaitForConsentApiLoaded
                    adsCheckGdprCookie={
                        featureSwitches['ads-check-gdpr-cookie']
                    }
                    onLoadRender={() => (
                        <DfpAd
                            {...props}
                            text={text}
                            isTraderaGptEnabled={
                                featureSwitches['ads-tradera-gpt']
                            }
                            isLoggingEnabled={false}
                        />
                    )}
                />
            </Provider>
        </ApplicationErrorBoundary>
    );
};

export default LocalizedDfpAd;
